// Externals
import { Route, Switch } from 'react-router-dom';

// Libraries
import { Header, CustomerCardSlideOut } from '@makemydeal/dr-sales-checkin-components';
import { useFetchCustomerVehicleDeals, Showroom } from '@makemydeal/dr-activities-sales-checkin';

// Config
import CustomerVehiclesSlideout from '../../activities/customerVehicles/components/CustomerVehiclesSlideout';
import CustomerVehiclesTradeInModal from '../../activities/customerVehicles/components/CustomerVehiclesTradeInModal';
import { DealRefreshModal } from '@makemydeal/dr-sales-checkin-components';
import { routingConfig } from '@makemydeal/dr-sales-checkin-types';

export const Dashboard = () => {
    const { isDealsBtnVisible, isOpen } = useFetchCustomerVehicleDeals();

    return (
        <>
            <Header />
            <Switch>
                <Route path={routingConfig.BASE_ROUTE} component={Showroom} />
                {/* future routes can be added here */}
            </Switch>
            {isDealsBtnVisible && isOpen && <CustomerVehiclesSlideout />}
            <CustomerVehiclesTradeInModal />
            <CustomerCardSlideOut />
            <DealRefreshModal />
        </>
    );
};

export default Dashboard;
